import React, { useState } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { InputCurrency, InputText } from '@goodfynd/react-web.lib.forms';
import { StyledFlex } from '@goodfynd/react-web.styles';
import { Text } from '@goodfynd/react-web.typography.text';
import { IconButton } from '@goodfynd/react-web.ui.icon-button';

import { InputSwitch } from '../../../forms';
import { EventCommissionExampleModal } from '../EventCommissionExampleModal';
import type { GoodfyndAdminFormFields } from '../types';
const GoodfyndAdmin = ({
  control,
  setValue,
  watch,
}: UseFormReturn<GoodfyndAdminFormFields>) => {
  const [showCommissionExample, toggleCommissionExample] = useState(false);

  const orderingFee = watch('orderingFee');
  const posFee = watch('posFee');
  return (
    <div>
      <InputSwitch
        control={control}
        helperText="* All food truck owners will receive an email with current event details?"
        label="Notify Nearby Trucks"
        name="notify"
      />
      <InputSwitch
        control={control}
        label="Is Public"
        name="isPublic"
        setValue={setValue}
      />

      <InputCurrency
        control={control}
        label="Ordering Service Fee %"
        name="orderingFee"
        helperText={
          <StyledFlex gap={2}>
            <Text>Replaces Goodfynd&apos;s default 10% fee</Text>
            <IconButton
              icon="info"
              onClick={() => toggleCommissionExample(true)}
            />
          </StyledFlex>
        }
      />

      <InputCurrency
        control={control}
        label="POS Service Fee %"
        name="posFee"
        helperText={
          <StyledFlex gap={2}>
            <Text>
              In addition to Goodfynd&apos;s default POS processing fee
            </Text>
            <IconButton
              icon="info"
              onClick={() => toggleCommissionExample(true)}
            />
          </StyledFlex>
        }
      />

      <InputText control={control} label="Receipt Image" name="receiptImage" />
      <InputText control={control} label="Sponsor Image" name="sponsorImage" />

      <InputSwitch
        control={control}
        defaultValue={true}
        label="Don't require subscription"
        name="dontRequireSubscription"
      />

      <InputText control={control} label="Subscription" name="subscription" />

      <InputText
        control={control}
        disabled
        label="Updated By"
        name="updatedBy"
      />

      <InputText
        control={control}
        disabled
        label="Uploaded By"
        name="uploadedBy"
      />

      {showCommissionExample && (
        <EventCommissionExampleModal
          close={() => toggleCommissionExample(false)}
          open
          orderingFee={orderingFee}
          posFee={posFee}
        />
      )}
    </div>
  );
};

export default GoodfyndAdmin;
